/**
 * @module utils/generator
 */

const {TestDataGenerator} = require('./test.data.generator/test.data.generator');

module.exports = {TestDataGenerator};
